module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/character/character-sheet/character-sheet-mechanics/move/move.component.css
// module id = ./src/app/character/character-sheet/character-sheet-mechanics/move/move.component.css
// module chunks = main